// @ts-nocheck
// LIBRARY
import React, { useEffect, useState } from 'react';

import { Drawer, Spin, Button, Col, Row } from 'antd';
import { Document, Page, pdfjs } from 'react-pdf';
import { CaretRightOutlined, CaretLeftOutlined } from '@ant-design/icons';
import Message from 'shared_components/message';

import { fetchGenerateView } from 'services/settings/qualityControl';

const GenerateView = ({ onClose, visible, PDFdata, action, onSave }) => {
	const [Loading, setLoading] = useState(false);
	const [pageNumber, setPageNumber] = useState(1);
	const [isReadyToPrint, setIsReadyToPrint] = useState(false);
	const [numPages, setNumPages] = useState(null);

	console.log({ onClose, visible, PDFdata, action, onSave });

	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
		setIsReadyToPrint(true);
	};

	const PageNavigation = action => {
		setPageNumber(prevPageNumber => (action === 'NEXT' ? prevPageNumber + 1 : prevPageNumber - 1));
	};

	//   const onClickApprove = async () => {
	//     const { getLabResultFormValues, onSaveSuccess } = props;
	//     const labResultFormValues = await getLabResultFormValues();
	//     console.log(labResultFormValues);
	//     const userSession = JSON.parse(
	//       sessionStorage.getItem(LOGGEDIN_USER_DATA)
	//     );
	//     const action = resultStatus === 'Approve' ? 'Unapproved' : 'Approved';

	//     if (!labResultFormValues.form.hasError && !labResultFormValues.remarks.hasError) {
	//       setIsApproving(true);
	//       const savedResults = await saveLabResult({
	//         results: labResultFormValues.form.results,
	//         remarks: labResultFormValues.remarks.value || '',
	//         userID: userSession.userID,
	//         action,
	//       });
	//       setIsApproving(false);
	//       if (savedResults) {
	//         onSaveSuccess();
	//         Message.success({ message: `Result successfully approved.` });
	//       }
	//     }
	//   };

	//   const onClickPrintPdf = async () => {
	//     const printPreview = await getPrintPreviewV2(requestID, sampleID);
	//     const payload = {
	//       requestID: requestID,
	//       sampleSpecimenID: sampleID,
	//       baseSixtyFour: printPreview.pdf,
	//     };
	//     console.log(payload);
	//     const response = await createPrintPdf(payload);
	//     if (response !== 500) {
	//       Message.success({ message: `Print Success.` });
	//     } else {
	//       Message.error({ message: `Failed to Print.` });
	//     }
	//   };

	//   const printResult = () => {
	//     const id = 'result';
	//     const iframe = document.frames ? document.frames[id] : document.getElementById(id);
	//     const iframeWindow = iframe.contentWindow || iframe;
	//     iframe.focus();
	//     iframeWindow.print();
	//   };

	return (
		<Drawer
			title="GENERATE VIEW"
			width="1060px"
			placement="right"
			closable
			onClose={() => onClose(false)}
			visible={visible}
		>
			<section>
				<Spin spinning={!isReadyToPrint && visible}>
					<iframe
						id="result"
						// src={imageSrc}
						// src={`${process.env.PUBLIC_URL}/reports/jrprintform/labhero/hematology/$lab.jrxml`}
						style={{ height: 0, width: 0, position: 'absolute' }}
						title="result"
					/>
					<Document
						file={`data:application/pdf;base64,${PDFdata}`}
						onLoadSuccess={onDocumentLoadSuccess}
						onLoadError={console.error}
						renderMode="svg"
						style={{ width: '100%' }}
					>
						<Page pageNumber={pageNumber} renderMode="svg" />
						<Row style={{ flexDirection: 'column', marginLeft: '50%' }}>
							<Col>
								{numPages === 1 ? null : (
									<>
										<Button
											type="text"
											icon={<CaretLeftOutlined />}
											onClick={() => PageNavigation('BACK')}
										/>
										<Button
											type="text"
											icon={<CaretRightOutlined />}
											onClick={() => PageNavigation('NEXT')}
										/>
									</>
								)}
							</Col>
							<Col>
								<p>
									Page {pageNumber} of {numPages}
								</p>
							</Col>
						</Row>
					</Document>
					<div></div>
				</Spin>
			</section>

			<section className="drawerFooter">
				<div>
					<Button shape="round" style={{ margin: 10, width: 120 }} onClick={() => onClose(false)}>
						CANCEL
					</Button>
					{action === 'add' ? (
						<Button
							shape="round"
							type="primary"
							onClick={() => onSave()}
							style={{ margin: 10, width: 120 }}
						>
							ADD
						</Button>
					) : null}
				</div>
			</section>
		</Drawer>
	);
};

export default GenerateView;
